export default __webpack_public_path__ + "static/media/deal-7.e287c8f7.webp";